<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <div class="row" v-loading="loading">
        <div class="col-xl-12 order-xl-1">
          <el-form :model="companyForm" :rules="rules" ref="companyForm">
            <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">{{ variables.get('company-information') }}</h3>
                  </div>
                  <!--                  <div class="col-4 text-right">-->
                  <!--                    <div class="row justify-content-end margin-right-1 margin-top-10">-->
                  <!--                      <base-button-->
                  <!--                          type="button"-->
                  <!--                          native-type="submit"-->
                  <!--                          class="btn btn-sm btn-primary"-->
                  <!--                          @click="updateCompany('companyForm',true)"-->
                  <!--                      >{{ variables.get('save') }}-->
                  <!--                      </base-button>-->
                  <!--                      <base-button-->
                  <!--                          type="button"-->
                  <!--                          native-type="submit"-->
                  <!--                          class="btn btn-sm btn-success"-->
                  <!--                          @click="updateCompanyAndPreview('companyForm',true)"-->
                  <!--                      >{{ variables.get('saveAndPreview') }}-->
                  <!--                      </base-button>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
              </div>
              <template>
                <h6 class="heading-small text-muted mb-4">{{ variables.get('generalInformation') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6">
                      <base-input
                          :label="variables.get('company-name')"
                          :placeholder="[companyForm.name]"
                          input-classes="form-control-alternative"
                          v-model="companyForm.name"
                      />
                    </div>

                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-status') }}</label>
                        <el-select class="w-100 form-control-alternative"
                                   v-model="companyForm.status"
                                   placeholder="Firma Durumu">
                          <el-option
                              v-for="stat in status"
                              :key="stat.value"
                              :label="stat.label"
                              :value="stat.value">
                          </el-option>
                        </el-select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-sector') }}</label>
                      <el-form-item prop="sector" class="form-control-alternative">
                        <el-input v-model="companyForm.sector"
                                  :placeholder="[variables.get('company-sector')]"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-6">
                      <div class="has-label"><label class="form-control-label">
                        {{ variables.get('company-type') }}</label>
                      </div>
                      <el-select class="w-100 form-control-alternative"
                                 v-model="companyForm.type"
                                 filterable
                                 :placeholder="[variables.get('company-type')].toString()">
                        <el-option
                            v-for="type in types"
                            :key="type.value"
                            :label="type.label"
                            :value="type.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="col-lg-6">
                      <div class="has-label"><label class="form-control-label">
                        {{ variables.get('company-personal-count') }}</label>
                      </div>
                      <el-select class="w-100 form-control-alternative"
                                 v-model="companyForm.personalcount"
                                 filterable
                                 :placeholder="[variables.get('company-personal-count')].toString()">
                        <el-option
                            v-for="count in personalcounts"
                            :key="count.value"
                            :label="count.label"
                            :value="count.value">
                        </el-option>
                      </el-select>
                    </div>

                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-establishment') }}</label>
                      <el-form-item prop="establishment" class="form-control-alternative">
                        <el-input v-model="companyForm.establishment"
                                  :placeholder="[variables.get('company-establishment')]" type="number"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-expertise') }}</label>
                      <el-form-item prop="expertise" class="form-control-alternative">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('forMoreProfession')"
                                    placement="top">
                          <el-input v-model="companyForm.expertise"
                                    :placeholder="[variables.get('company-expertise')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-head-office') }}</label>
                      <el-form-item prop="headoffice" class="form-control-alternative">
                        <el-input v-model="companyForm.headoffice"
                                  :placeholder="[variables.get('company-head-office')]"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <hr class="my-4"/>
                <!-- Address -->
                <h6 class="heading-small text-muted mb-4">{{ variables.get('company-contact-information') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <label class="form-control-label">{{ variables.get('company-address') }}</label>
                      <el-form-item prop="address" class="form-control-alternative">
                        <el-input v-model="companyForm.address"
                                  :placeholder="[variables.get('company-address')]"></el-input>
                      </el-form-item>
                    </div>

                    <div class="col-lg-12 mb-3">
                      <base-checkbox v-model="companyForm.multiple_address">
                        <span class="text-sm">Birden Çok Ofisimiz Var</span>
                      </base-checkbox>
                    </div>
                    <div class="col-lg-12">
                      <base-input v-if="companyForm.multiple_address"
                                  label="Birden çok ofisiniz varsa bu alana girebilirsiniz">
                        <vue-editor class="bg-white" :editorToolbar="customToolbar"
                                    v-model="companyForm.other_address"></vue-editor>
                      </base-input>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-phone') }}</label>
                      <el-form-item prop="phone" class="form-control-alternative">
                        <the-mask class="el-input__inner" :mask="['(###) ###-##-##']" v-model="companyForm.phone"
                                  :placeholder="[variables.get('company-phone')]"/>
                        <span v-if="phoneError"
                              class="mask-error">Lütfen 10 karakter ve başında 0 olmadan giriniz</span>
                      </el-form-item>
                      <!--                      <VuePhoneNumberInput default-country-code="TR"-->
                      <!--                                           :translations="{ countrySelectorLabel: 'Ülke Kodu',-->
                      <!--                                           countrySelectorError: 'Ülke Seçmediniz',-->
                      <!--                                           phoneNumberLabel: 'Telefon Numarası',-->
                      <!--                                           example:'Hatalı Numara. Örnek: '}"-->
                      <!--                                           v-model="companyForm.phone"-->
                      <!--                                           :required="true"-->
                      <!--                                           :error="showPayload._isValid"-->
                      <!--                                           @update="showPayload"-->
                      <!--                      />-->
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-pbx') }}</label>
                      <el-form-item prop="pbx" class="form-control-alternative">
                        <el-input v-model="companyForm.pbx"
                                  :placeholder="[variables.get('company-pbx')]" type="number"></el-input>
                      </el-form-item>
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-mobile_phone') }}</label>
                      <el-form-item prop="mobile_phone" class="form-control-alternative">
                        <the-mask class="el-input__inner" :mask="'(###) ###-##-##'" v-model="companyForm.mobile_phone"
                                  :placeholder="[variables.get('company-mobile_phone')]"/>
                        <span v-if="mobilePhoneError"
                              class="mask-error">Lütfen 10 karakter ve başında 0 olmadan giriniz</span>
                      </el-form-item>

                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">{{ variables.get('company-website') }}</label>
                      <el-form-item prop="website" class="form-control-alternative">
                        <el-tooltip class="item" effect="dark"
                                    content="Lütfen başında http:// ya da https:// olacak şekilde giriniz."
                                    placement="top">
                          <el-input :placeholder="[variables.get('company-website')]"
                                    v-model="companyForm.website"></el-input>
                        </el-tooltip>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <hr class="my-4"/>
                <h6 class="heading-small text-muted mb-4">{{ variables.get('company-about') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <base-input
                          :label="variables.get('company-detail')">
                        <vue-editor class="bg-white" :editorToolbar="customToolbar"
                                    v-model="companyForm.detail"></vue-editor>
                      </base-input>
                    </div>
                  </div>
                </div>
                <hr class="my-4"/>
                <h6 class="heading-small text-muted">{{ variables.get('company-about') }}</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-6 mb-2">
                      <label class="form-control-label">{{ variables.get('company-facebook') }}</label>
                      <el-form-item prop="facebook" class="form-control-alternative mb-0">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('companyPageInFacebook')"
                                    placement="top">
                          <el-input v-model="companyForm.facebook"
                                    :placeholder="[variables.get('company-facebook')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <small class="d-none d-lg-block">* {{ variables.get('companyPageInFacebook') }}</small>
                    </div>
                    <div class="col-lg-6 mb-2">
                      <label class="form-control-label">{{ variables.get('company-twitter') }}</label>
                      <el-form-item prop="twitter" class="form-control-alternative mb-0">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('companyPageInTwitter')"
                                    placement="top">
                          <el-input v-model="companyForm.twitter"
                                    :placeholder="[variables.get('company-twitter')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <small class="d-none d-lg-block">* {{ variables.get('companyPageInTwitter') }}</small>
                    </div>
                    <div class="col-lg-6 mb-2">
                      <label class="form-control-label">{{ variables.get('company-instagram') }}</label>
                      <el-form-item prop="instagram" class="form-control-alternative mb-0">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('companyPageInInstagram')"
                                    placement="top">
                          <el-input v-model="companyForm.instagram"
                                    :placeholder="[variables.get('company-instagram')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <small class="d-none d-lg-block">* {{ variables.get('companyPageInInstagram') }}</small>
                    </div>
                    <div class="col-lg-6 mb-2">
                      <label class="form-control-label">{{ variables.get('company-linkedin') }}</label>
                      <el-form-item prop="linkedin" class="form-control-alternative mb-0">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('companyPageInLinkedin')"
                                    placement="top">
                          <el-input v-model="companyForm.linkedin"
                                    :placeholder="[variables.get('company-linkedin')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <small class="d-none d-lg-block">* {{ variables.get('companyPageInLinkedin') }}</small>
                    </div>
                    <div class="col-lg-6 mb-2">
                      <label class="form-control-label">{{ variables.get('company-youtube') }}</label>
                      <el-form-item prop="youtube" class="form-control-alternative mb-0">
                        <el-tooltip class="item" effect="dark"
                                    :content="variables.get('companyPageInYoutube')"
                                    placement="top">
                          <el-input v-model="companyForm.youtube"
                                    :placeholder="[variables.get('company-youtube')]"></el-input>
                        </el-tooltip>
                      </el-form-item>
                      <small class="d-none d-lg-block">* {{ variables.get('companyPageInYoutube') }}</small>
                    </div>
                  </div>
                </div>
                <hr class="my-4"/>
                <div class="row justify-content-end margin-right-1 margin-top-10">
                  <el-button
                      size="small"
                      type="primary"
                      @click="updateCompany('companyForm',false)"
                  >{{ variables.get('save') }}
                  </el-button>
                </div>
              </template>
            </card>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import VuePhoneNumberInput from 'vue-phone-number-input';
//import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import {variables} from "../../langs/tr";
import {VueEditor} from "vue2-editor";
import * as axios from "axios";
import {mapGetters} from "vuex";
import {TheMask} from 'vue-the-mask'
import {vueEditorCustomToolbar} from "@/plugins/vue-editor-toolbar";


export default {
  name: 'CompanyDetail',
  components: {
    VueEditor,
    TheMask
    //VuePhoneNumberInput
  },
  computed: {
    ...mapGetters({
      getUserModel: "userModule/getUserModel",
    })
  },
  data() {
    return {
      variables,
      loading: true,
      phoneError: false,
      mobilePhoneError: false,
      checkboxes: {
        unchecked: false,
        checked: true,
        uncheckedDisabled: false,
        checkedDisabled: true
      },
      value: [],
      companyForm: {
        id: null,
        name: "",
        phone: "",
        //phone_valid:"",
        phone_visibility: null,
        mobile_phone: "",
        mobile_phone_visibility: null,
        pbx: "",
        pbx_visibility: null,
        address: "",
        multiple_address: false,
        other_address: "",
        address_visibility: null,
        detail: "",
        video1url: "",
        video1url_visibility: null,
        logo: "",
        website: "",
        website_visibility: null,
        sector: "",
        sector_visibility: null,
        personalcount: "",
        personalcount_visibility: null,
        headoffice: "",
        headoffice_visibility: null,
        type: "",
        type_visibility: null,
        establishment: "",
        establishment_visibility: null,
        expertise: "",
        expertise_visibility: null,
        facebook: "",
        twitter: "",
        linkedin: "",
        instagram: "",
        youtube: "",
        map: "",
        map_visibility: null,
        status:null,
      },
      customToolbar: vueEditorCustomToolbar,
      rules: {
        phone: [
          {
            required: true,
            min: 10,
            max: 10,
            message: 'Lütfen 10 karakter ve başında 0 olmadan giriniz',
            trigger: 'blur'
          }
        ],
        mobile_phone: [
          {
            required: true,
            min: 10,
            max: 10,
            message: 'Lütfen 10 karakter ve başında 0 olmadan giriniz',
            trigger: 'blur'
          }
        ],
        pbx: [
          {required:false,min: 10, max: 10, message: 'Lütfen 10 karakter ve başında 0 olmadan giriniz', trigger: 'blur'}
        ],
        headoffice: [
          {required: true, message: 'Lütfen firmanın merkez ofisi şehrini giriniz', trigger: 'blur'},
          {max: 50, message: 'Çok fazla karakter girdiniz', trigger: 'blur'}
        ],
        expertise: [
          {required: true, message: 'Lütfen uzmanlık alanı bilgisi giriniz', trigger: 'blur'},
          {max: 191, message: 'Çok fazla karakter girdiniz', trigger: 'blur'}
        ],
        address: [
          {required: true, message: 'Lütfen adres bilgisi giriniz', trigger: 'blur'}
        ],
        sector: [
          {required: true, message: 'Lütfen firmanın faaliyet gösterdiği sektörü giriniz', trigger: 'blur'}
        ],
        establishment: [
          {required: true, message: 'Lütfen firma kuruluş yılı giriniz', trigger: 'blur'},
          {max: 4, message: 'Lütfen sadece yıl giriniz', trigger: 'blur'},
        ],
        type: [
          {required: true, message: 'Lütfen firma türü seçiniz', trigger: 'blur'}
        ],
        website: [
          {
            required: true,
            message: 'Web sitesini başında http:// ya da https:// olacak şekilde giriniz',
            trigger: 'blur'
          }
        ],
        // facebook: [
        //   {min: 3, message: 'Lütfen Facebook hesabınızı doğru şekilde giriniz', trigger: 'blur'}
        // ],
        // twitter: [
        //   {min: 3, message: 'Lütfen Twitter hesabınızı doğru şekilde giriniz', trigger: 'blur'}
        // ],
        // youtube: [
        //   {min: 3, message: 'Lütfen Youtube hesabınızı doğru şekilde giriniz', trigger: 'blur'}
        // ],
        // instagram: [
        //   {min: 3, message: 'Lütfen Instagram hesabınızı doğru şekilde giriniz', trigger: 'blur'}
        // ],
        // linkedin: [
        //   {min: 3, message: 'Lütfen Linkedin hesabınızı doğru şekilde giriniz', trigger: 'blur'}
        // ],
      },
      types: [{
        value: 'Kamu Kurumu',
        label: 'Kamu Kurumu'
      }, {
        value: 'Özel Şirket',
        label: 'Özel Şirket (A.Ş. / LTD)'
      }, {
        value: 'Halka Açık Şirket',
        label: 'Halka Açık Şirket'
      }, {
        value: 'Ortaklık',
        label: 'Ortaklık'
      }, {
        value: 'Diğer',
        label: 'Diğer'
      }],

      status: [{
        value: 0,
        label: 'Pasif'
      }, {
        value: 1,
        label: 'Aktif'
      }],

      personalcounts: [{
        value: '1 - 10',
        label: '1 - 10'
      }, {
        value: '11 - 50',
        label: '11 - 50'
      }, {
        value: '51 - 100',
        label: '51 - 100'
      }, {
        value: '101 - 500',
        label: '101 - 500'
      }, {
        value: '501 - 1000',
        label: '501 - 1000'
      }, {
        value: '1.001 - 5000',
        label: '1.001 - 5000'
      }, {
        value: '5.001 - 10.000',
        label: '5.001 - 10.000'
      }, {
        value: '10.001+',
        label: '10.001 ve üzeri'
      }]
    }
  },
  created() {
    this.getCompanyInformation();
  },
  methods: {
    // showPayload(payload) {
    //   this.phone_valid = payload.isValid;
    // },
    getCompanyInformation() {
      axios.get("admin/company/detail/"+this.$route.params.id).then((response) => {
        this.companyForm = response.data;
        this.loading = false;
      })
      .catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // sayıların uzunluğunu veren fonksiyon
    digits(num, count = 0) {
      if (num) {
        return this.digits(Math.floor(num / 10), ++count);
      }
      return count;
    },
    updateCompany(formName, redirect) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postCompany(redirect);
        }
      });
    },
    async postCompany(redirect) {
      this.mobilePhoneError = false;
      this.phoneError = false;

      const mobilePhoneLength = this.digits(this.companyForm.mobile_phone);
      const phone = this.digits(this.companyForm.phone);
      if (this.companyForm.mobile_phone == "" || mobilePhoneLength < 10) {
        this.mobilePhoneError = true;
      }
      if (this.companyForm.phone == "" || phone < 10) {
        this.phoneError = true;
      }

      await axios.post('admin/company/update', this.companyForm).then(response => {
        if (response.status === 200) {
          this.$notify.success({
            title: 'Başarılı',
            message: 'Bilgi güncellemesi başarıyla gerçekleştirildi.',
          });
          if (redirect === true) {
            var link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            link.href = 'https://vizyonergenc.com/firma/' + this.companyForm.id + '?ref=company-preview';
            link.target = '_blank';
            var event = new MouseEvent('click', {
              'view': window,
              'bubbles': false,
              'cancelable': true
            });
            link.dispatchEvent(event);

          }
        }
        // eslint-disable-next-line no-unused-vars
      }).catch(error => {
        this.$notify.info({
          title: 'Bir hata oluştu',
          message: 'Boş alan bırakmış ya da yanlış bir bilgi girmiş olabilirsiniz.',
        });
      });
    }
  }
};
</script>
<style scoped>
.el-input-group__append, .el-input-group__prepend, .el-input__inner {
  border-radius: 0.375rem !important;
  border: none !important;
  height: 42px !important;
  padding: 0.625rem 0.75rem !important;
  transition: box-shadow .15s ease, -webkit-box-shadow .15s ease !important;
}

.el-input__inner:focus {
  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.mask-error {
  color: #F56C6C;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
  left: 14px;
}
</style>
